import { render, staticRenderFns } from "./ChildBehavior.vue?vue&type=template&id=6d1d8f48&lang=pug"
import script from "./ChildBehavior.vue?vue&type=script&lang=js"
export * from "./ChildBehavior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports